var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7065 18H4.94756C4.85383 18 4.76067 17.9876 4.67157 17.9585C3.36665 17.5323 1 16.0723 1 13.2516C1 10.066 3.25409 8.97791 5.54397 8.75235C6.0936 8.69822 6.53621 8.25457 6.58957 7.70487C7.09382 2.51081 11.5347 1 14.5334 1C17.5439 1 21.1517 2.56276 22.2496 7.77272C22.3589 8.29147 22.8272 8.6646 23.3562 8.69971C25.3073 8.82923 28 9.83897 28 13.2516C28 16.0175 25.6106 17.5048 24.2896 17.9548C24.1967 17.9864 24.0994 18 24.0013 18H17.249",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18V8",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L14.1464 7.85355C14.3417 7.65829 14.6583 7.65829 14.8536 7.85355L18 11",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.19806cf1f53ad1d882cb51e978511107.svg";
export { ForwardRef as ReactComponent };